<template>
  <div>
    <div class="steps">
      <div class="step animated slideInLeft" style="width:50%;"></div>
    </div>
    <div class="bg-white border-bottom">
      <div class="container pt-4 pt-sm-3 pb-2">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
            <h1 v-if="asset" class="h4">
              <span class="h3 d-block mb-1">
                <span
                  class="badge badge-dark text-uppercase easy-select"
                >{{asset.details.registrationNumber}}</span>
              </span>
              <span class="h5 d-block">
                <small class="text-uppercase text-muted">
                  {{ asset.details.manufacturer}}
                  <span
                    v-if="!asset.pnoTrailer"
                  >{{ asset.details.category }}</span>
                  {{ asset.details.name }}
                  <small
                    class="ml-1"
                  >({{ asset.details.modelYear }})</small>
                </small>
              </span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container py-4">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
          <p class="text-uppercase small grey mt-2 mb-1">Tire Positions</p>
          <div class="list-group mb-4" v-if="newTireReport">
            <router-link
              v-for="tirePosition in sortedLayoutList"
              :key="tirePosition"
              :to="{ name: 'tire-change', params: { id: newTireReport.tireReportId, tirePosition: tirePosition } }"
              class="list-group-item px-3"
            >
              <i
                class="fal fa-fw mr-2"
                v-bind:class="{ 'green fa-check-circle': newTireReport.tires && newTireReport.tires[tirePosition], 'grey fa-circle': !newTireReport.tires || !newTireReport.tires[tirePosition] }"
              ></i>
              {{ tirePosition | shorthandlabel }}
              <i
                class="fal fa-chevron-right float-right ml-3 mt-1"
              ></i>
              <small class="float-right mt-1 grey">
                <translate translate-context="inspection">{{tirePosition}}</translate>
              </small>
            </router-link>

            <router-link
              :to="{ name: 'tire-change', params: { id: newTireReport.tireReportId, tirePosition: 'sparewheel1' } }"
              class="list-group-item px-3"
            >
              <i
                class="fal fa-fw mr-2"
                v-bind:class="{ 'green fa-check-circle': newTireReport.tires && newTireReport.tires['sparewheel1'], 'grey fa-circle': !newTireReport.tires || !newTireReport.tires['sparewheel1'] }"
              ></i>
              SW
              <i class="fal fa-chevron-right float-right ml-3 mt-1 grey"></i>
              <small class="float-right mt-1 grey">
                <translate translate-context="inspection">sparewheel1</translate>
              </small>
            </router-link>
          </div>
          <p class="text-uppercase small grey mt-2 mb-1">Details</p>
          <div class="list-group mb-4">
            <router-link :to="{ name: 'tire-workshop' }" class="list-group-item px-3">
              <i
                class="fal fa-fw mr-2"
                :class="[newTireReport && newTireReport.workshop ? 'green fa-check-circle' : 'red fa-times-circle' ]"
              ></i>
              Workshop
              <i class="fal fa-chevron-right float-right ml-3 mt-1 grey"></i>
            </router-link>
            <router-link :to="{ name: 'tire-remarks' }" class="list-group-item px-3">
              <i
                class="fal fa-fw mr-2"
                v-bind:class="{ 'green fa-check-circle': newTireReport && newTireReport.remark, 'grey fa-circle': !newTireReport || !newTireReport.remark }"
              ></i>Remarks
              <i class="fal fa-chevron-right float-right ml-3 mt-1 grey"></i>
            </router-link>
          </div>
          <button
            @click="submitNewTireReport"
            :disabled="!canComplete"
            class="btn btn-info btn-lg btn-block mt-3"
          >Complete tire report</button>
          <small class="d-block mt-3">
            <a href="#cancelreport" data-toggle="modal" class="grey">
              <i class="far fa-trash-alt mr-1"></i>Cancel report
            </a>
          </small>
        </div>
      </div>
    </div>

    <div id="cancelreport" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Are you sure?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p v-if="asset" class="my-2">
              All your temporary tire report data on
              <strong>{{asset.details.registrationNumber}}</strong> will be lost.
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-light" data-dismiss="modal">Dismiss</button>
            <button
              @click="cancelTireReport"
              class="btn btn-info"
              data-dismiss="modal"
            >Cancel report</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex"

const lo = /([1-9])Louter/
const li = /([1-9])Linner/
const ro = /([1-9])Router/
const ri = /([1-9])Rinner/

const shorthandlabel = (key) => {
  const lom = key.match(lo)
  const lim = key.match(li)
  const rom = key.match(ro)
  const rim = key.match(ri)

  if (lom) {
    return `${lom[1]}LO`
  } else if (lim) {
    return `${lim[1]}LI`
  } else if (rom) {
    return `${rom[1]}RO`
  } else if (rim) {
    return `${rim[1]}RI`
  } else if (key === "sparewheel1") {
    return "SW"
  }
  return key
}

export default {
  metaInfo() {
    return {
      title:
        `${
          this.asset ? this.asset.details.registrationNumber : "Tire report"
        }` + ": Tire report"
    };
  },
  filters: {
    shorthandlabel,
  },
  computed: {
    ...mapState("tireReports", ["asset", "newTireReport"]),
    sortedLayoutList() {
      if (!this.asset || !this.asset.tires) return [];
      return Object.keys(this.asset.tires).sort((a, b) => {
        const tireA = a.toUpperCase();
        const tireB = b.toUpperCase();
        return tireA < tireB ? -1 : tireA > tireB ? 1 : 0;
      });
    },
    canComplete() {
      return (
        this.newTireReport &&
        this.newTireReport.tires &&
        Object.keys(this.newTireReport.tires).length > 0 &&
        this.newTireReport.workshop
      );
    }
  },
  mounted() {
    if (!this.newTireReport || !this.newTireReport.tireReportId) {
      if (this.$route.params.id) {
        this.continueIncompleteReport(this.$route.params.id);
      } else {
        this.$router.replace({ name: "frontpage" });
      }
    }
  },
  methods: {
    ...mapActions("tireReports", ["submitNewTireReport", "cancelTireReport", "continueIncompleteReport"])
  }
};
</script>
